<script setup lang="ts">
defineProps<{
  href: string
  provider: SocialProvider
  label?: string
  size?: string
}>()

const mapping = {
  facebook: 'fa7-brands:facebook-f',
  instagram: 'fa7-brands:instagram',
  linkedin: 'fa7-brands:linkedin-in',
  x: 'fa7-brands:x-twitter',
  tiktok: 'fa7-brands:tiktok',
  youtube: 'fa7-brands:youtube',
} satisfies Record<SocialProvider, string>
</script>

<template>
  <UButton
    :href="href"
    :aria-label="label || `Lenke til Aschehougs ${provider}-side`"
    :icon="mapping[provider]"
    class="rounded-full"
  />
</template>
